// import "url-polyfill";
import { APP_PDC_URL } from "../../config";
import cuid from "cuid";
import uuidv4 from "uuid/v4";
import axios from "axios";

function trimAndLower(id) {
  return id != null ? id.trim().toLowerCase() : id;
}

export const ssoConstants = {
  SSO_START: "SSO_START",
  SSO_SUCCESS: "SSO_SUCCESS",
  SSO_CONNECT: "SSO_CONNECT",
  SSO_ERROR: "SSO_ERROR",
  SSO_RESET: "SSO_RESET",
  SSO_RESET_CREDENTIAL: "SSO_RESET_CREDENTIAL"
};

export function login_sso(
  appName, userId, password
) {
  return async(dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ssoConstants.SSO_START
      });

      userId = trimAndLower(userId);
      const requestId = cuid();
      const correlationId = uuidv4();

      let request = {
        method: "POST",
        url: `${APP_PDC_URL}/authsso/tsLogin`,
        headers: {
          Authorization: ""
        },
        data: {
          digest: {
            tsId: userId,
            tsPwd: password
          },
          header: {
            correlationId: correlationId,
            requestId: requestId
          }
        }
      };

      axios(request)
        .then((result) => {
          if (result.data.connected) {
            dispatch({
              type: ssoConstants.SSO_SUCCESS,
              payload: { ssoAuth: { login: userId } }
            });
            const encodedToken = result.data.agyoAccessToken.split(".")[1];
            const decodedToken = atob(atob(btoa(encodedToken)));
            const objToken = JSON.parse(decodedToken);

            dispatch({
              type: ssoConstants.LOGIN_SUCCESS,
              payload: {
                loginAuth: {
                  securityToken: result.data.agyoAccessToken,
                  id: objToken.sub,
                  appName,
                  refreshToken: result.data.agyoRefreshToken,
                  correlationId: correlationId,
                  requestId: requestId
                }
              }
            });
            resolve(result.data);
          } else {
            dispatch({
              type: ssoConstants.SSO_CONNECT,
              payload: {
                ssoCredential: {
                  tsId: userId,
                  tsPass: password
                }
              }
            });
            resolve(result.data);
          }
        })
        .catch((response) => {
          dispatch({
            type: ssoConstants.SSO_ERROR,
            error: "Accesso fallito! "
          });
        });
    });
  };
}
